import type { SelectDropdown, SelectDropdownParts } from "src/components";
import type { UserAccessWeb } from "src/datahandling/redux/api/rtkQueryCodeGen/accessApi/accessApiInjections";
import type { CompanyType } from "src/models/types/userSettings.types";

export function useCompanySelectorTransformer(data: UserAccessWeb, selectedCompany?: CompanyType) {
    const selectedOption : SelectDropdownParts.Item.Props = {
        id: "",
        text: "",
        value: undefined
    };

    if(selectedCompany) {
        selectedOption.id = selectedCompany.id ?? "unknownId";
        selectedOption.text = selectedCompany.name ?? "unknownName";
        selectedOption.value = {
            id: selectedCompany.id ?? "",
            name: selectedCompany.name ?? "",
        } as CompanyType;
    } else {
        selectedOption.id = data?.companyAccesses?.[0]?.gosId ?? "unknownId";
        selectedOption.text = data?.companyAccesses?.[0]?.name ?? "unknownName";
        selectedOption.value = {
            id: data?.companyAccesses?.[0]?.gosId ?? "",
            name: data?.companyAccesses?.[0]?.name ?? "",
        } as CompanyType;
    }

    const companies : SelectDropdown.Props["options"] = data?.companyAccesses?.map((company) => {
        return {
            id: company.gosId ?? "",
            text: company.name ?? "",
            value: {
                id: company.gosId ?? "",
                name: company.name ?? "",
            } as CompanyType
        }
    }) ?? [];

    return {
        options: companies as SelectDropdownParts.Item.Props[],
        selected: selectedOption,
    };
}